"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.notify.done': 'Grazie per avermi creato. Dimmi come posso aiutarti.',
};
